<div class="container-fluid container-height p-0">
  <div class="row p-0 mx-0">
    <!-- <div class="row container-fluid p-0"> -->
      <div class="col-12 col-md-6 px-0 ps-sm-0 pe-sm-2 px-xl-0">
        <div class="row mx-0">
        <div class="col-12 col-xl-6 px-0 mb-md-3 mb-xl-0">
          <div class="me-50">
            <div class="col p-0 mb-3">
              <app-input
                [inputLabel]="'D & B Number'"
                [inputType]="'text'"
                onlyNumbers
                inputMaxlength="9" 
                [inputValue]="  insertUpdateGeneralInfoCompany.detailsInfo.dAndBNumber "
                (inputValueEmit)=" insertUpdateGeneralInfoCompany.detailsInfo.dAndBNumber = $event "
                >
              </app-input>
            </div>
            <div class="col p-0 mb-3">
              <app-dropdown
                [selectLabel]="'Industry'"
                [data]="industryValues"
                [selectValue]="industryId"
                [optionDisable]="industryDisable"
                (selectValueEmit)="industrySelected($event)"
                [required]="false"
              >
              </app-dropdown>
            </div>
            <div class="col p-0 mb-3">
              <div class="row mx-0">
                <div class="col-12 col-md-6 p-0 pe-0 pe-md-2 mb-3 mb-md-0 col-lg-6 requirement position-relative">
                  <!-- <app-input
                    [inputLabel]="'SIC Code'"
                    [inputType]="'text'"
                    onlyNumbers
                    isSmallInput="true"
                    [inputValue]="insertUpdateGeneralInfoCompany.detailsInfo.sicCode"
                    (inputValueEmit)="
                      insertUpdateGeneralInfoCompany.detailsInfo.sicCode = $event
                    "
                  >
                  </app-input> -->
                  <app-input-search
                  class="code"
                  [inputLabel]="'SIC Code'"
                  [inputType]="'text'"
                  onlyNumbers
                  isSmallInput="true"
                  [inputValue]="sicCode"
                  (inputValueEmit)="sicSelected($event)"
                  id="typeahead-format"
                  [ngbTypeahead]="searchSicCode"
                  [resultFormatter]="formatter"
                  [inputMaxlength] = "8"
                >
                </app-input-search>
                <div *ngIf="errorMessageSIC" class="font-10 position-absolute text-danger min-width">
                  SIC code is not available.
                </div>
            
                </div>
                <div class="col-xl-6 ps-0 ps-md-2 p-0 col-md-6 col-lg-6 requirement position-relative">
                  <!-- <app-input
                    [inputLabel]="'NAICS Code'"
                    [inputType]="'text'"
                    onlyNumbers
                    isSmallInput="true"
                    [inputValue]="insertUpdateGeneralInfoCompany.detailsInfo.naicsCode
                    "
                    (inputValueEmit)="
                      insertUpdateGeneralInfoCompany.detailsInfo.naicsCode =
                        $event
                    "
                  >
                  </app-input> -->
                  <app-input-search
                   class="code"
                  [inputLabel]="'NAICS Code'"
                    [inputType]="'text'"
                    onlyNumbers
                    isSmallInput="true"
                    [inputValue]="naicsCode"
                    (inputValueEmit)="naicsSelected($event)"
                  id="typeahead-format"
                  [ngbTypeahead]="searchNAICSCode"
                  [resultFormatter]="formatter"
                  [inputMaxlength] = "6"
                  >
                </app-input-search>
                <div *ngIf="errorMessageNAICS" class="font-10 position-absolute text-danger min-width">
                  NAICS code is not available.
                </div>

                </div>
              </div>
            </div>
            <div class="col p-0 mb-3 mb-md-0">
              <app-dropdown
                [selectLabel]="'Scope'"
                [data]="scopeList"
                [selectValue]="insertUpdateGeneralInfoCompany.detailsInfo.scopeId"
                (selectValueEmit)="insertUpdateGeneralInfoCompany.detailsInfo.scopeId = $event"
              >
              </app-dropdown>
            </div>
          </div>
        </div>
        <div class="col-12 col-xl-6 px-0">
          <div class="me-50">
            <div class="col p-0 mb-3">
              <div class="col p-0 mb-3">
                <!-- <app-dropdown
                  [selectLabel]="'Entity Type'"
                  [data]=""
                  (selectValueEmit)="
                    insertUpdateGeneralInfoCompany.detailsInfo.entityType = $event
                  "
                >
                </app-dropdown> -->
                <app-input
                [inputLabel]="'Entity Type'"
                [inputType]="'text'"
                isSmallInput="true"
                [inputValue]="insertUpdateGeneralInfoCompany.detailsInfo.entityType"
                (inputValueEmit)="insertUpdateGeneralInfoCompany.detailsInfo.entityType = $event"
              >
              </app-input>
  
              </div>
            </div>
            <div class="col p-0 mb-3">
              <div class="row mx-0">
                <div class="col-12 col-md-6 p-0 pe-0 pe-md-2 mb-3 mb-md-0 col-lg-6">
                  <app-input
                    [inputLabel]="'Employees'"
                    [inputType]="'text'"
                    onlyNumbers
                    [inputMaxlength]="100"
                    isSmallInput="true"
                    [inputValue]="insertUpdateGeneralInfoCompany.detailsInfo.employee"
                    (inputValueEmit)="insertUpdateGeneralInfoCompany.detailsInfo.employee = $event"
                  >
                  </app-input>
                </div>
                <div class="col-xl-6 ps-0 ps-md-2 p-0 col-md-6 col-lg-6">
                  <app-input
                    numberFormat
                    [inputLabel]="'Revenue'"
                    [inputType]="'text'"
                    isSmallInput="true"
                    [inputValue]="insertUpdateGeneralInfoCompany.detailsInfo.revenue"
                    (inputValueEmit)="insertUpdateGeneralInfoCompany.detailsInfo.revenue = $event"
                  >
                  </app-input>
                </div>
              </div>
            </div>
            <div class="col p-0 mb-3">
              <div class="col p-0 mb-3">
                <!-- <app-dropdown
                  [selectLabel]="'Parent Company'"
                  [data]=""
                  (selectValueEmit)="
                    insertUpdateGeneralInfoCompany.detailsInfo.parentCompanyId =
                      $event
                  "
                >
                </app-dropdown> -->
  
                <app-input
                [inputLabel]="'Parent Company'"
                [inputType]="'text'"
                isSmallInput="true"
                [inputValue]="
                insertUpdateGeneralInfoCompany.detailsInfo.parentCompany"
                (inputValueEmit)="insertUpdateGeneralInfoCompany.detailsInfo.parentCompany =$event"
              >
              </app-input>
              </div>
            </div>
            <div class="col p-0 mb-3 mb-md-0">
              <app-dropdown
                [selectLabel]="'Currency'"
                [data]="currencyList"
                [selectValue]="insertUpdateGeneralInfoCompany.detailsInfo.currencyId"
                (selectValueEmit)="insertUpdateGeneralInfoCompany.detailsInfo.currencyId = $event"
              >
              </app-dropdown>
            </div>
          </div>
        </div>
      </div>
      </div>
      <div class="col-12 col-md-6 px-0 pe-sm-0 ps-sm-2 px-xl-0">
        <div class="row mx-0">
        <div class="col-xl-6 px-0 mb-md-3 mb-xl-0">
          <div class="me-50">
            <div class="col p-0 mb-3">
              <app-input
                [inputLabel]="'Tax ID'"
                [inputType]="'text'"
                [inputMaxlength]="15"
                [inputValue]="insertUpdateGeneralInfoCompany.detailsInfo.taxId"
                (inputValueEmit)="insertUpdateGeneralInfoCompany.detailsInfo.taxId = $event"
              >
              </app-input>
            </div>
            <div class="col p-0 mb-3">
              <app-input
                [inputLabel]="'VAT/RFC/CNPJ'"
                [inputType]="'text'"
                [inputMaxlength]="15"
                [inputValue]="insertUpdateGeneralInfoCompany.detailsInfo.vaT_RFC_CNPJ"
                (inputValueEmit)="insertUpdateGeneralInfoCompany.detailsInfo.vaT_RFC_CNPJ = $event"
              >
              </app-input>
            </div>
            <div class="col p-0 mb-3">
              <app-input
                [inputLabel]="'Reseller ID'"
                [inputMaxlength]="15"
                [inputType]="'text'"
                [inputValue]="insertUpdateGeneralInfoCompany.detailsInfo.resellerId"
                (inputValueEmit)="insertUpdateGeneralInfoCompany.detailsInfo.resellerId = $event"
              >
              </app-input>
            </div>
            <div class="col p-0 mb-3 mb-md-0">
              <!-- <app-input
                [inputLabel]="'Reseller ID Expiration Date'"
                [inputType]="'text'"
                [inputMaxlength]="10"
                [inputValue]="insertUpdateGeneralInfoCompany.detailsInfo.resellerIdExpirationDate
                "(inputValueEmit)="insertUpdateGeneralInfoCompany.detailsInfo.resellerIdExpirationDate =$event">
              </app-input> -->
              <app-date-picker
              style="width: 21%;"
              [time]="false"
              [inputLabel]="'Reseller ID Expiration Date'"
              [inputValue]="resellerDate"
              [minDate]="minDate"
              (inputValueEmit)="resellerDate=$event;reselletId()"
            ></app-date-picker>
            </div>
          </div>
        </div>
        <div class="col-xl-6 px-0">
          <div class="row mx-0" *ngIf="headName == 'Add Vendor'">
            <div class="col-xl-12 mb-3 px-0">
              <app-input
                [inputLabel]="'Vendor Specialty'"
                [inputType]="'text'"
                [inputValue]="insertUpdateGeneralInfoCompany.detailsInfo.vendorSpecialty"
                (inputValueEmit)="insertUpdateGeneralInfoCompany.detailsInfo.vendorSpecialty =$event"
                >
              </app-input>
            </div>
          </div>
          <div class="d-flex flex-column h-100">
            <app-textarea 
                class="h-100"
                [label]="'Notes'"
                [isRequired]="false"
                [textareaHeight]="(headName === 'Add Vendor' || headName === 'Update Vendor') ? '180px' : '100%'"
                [name]="'notes'"
                [id]="'notes'"
                [inputValue]="insertUpdateGeneralInfoCompany.detailsInfo.notes"
                (inputValueEmit)="insertUpdateGeneralInfoCompany.detailsInfo.notes = $event"
            ></app-textarea>
          </div>
        </div>
      </div>
      </div>
    <!-- </div> -->
  </div>
</div>
